import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractRefundPaymentEmailTemplate.Delete.IRequest;
type Response = Api.Core.ContractRefundPaymentEmailTemplate.Delete.IResponse;
type Headers = Api.Core.ContractRefundPaymentEmailTemplate.Delete.IHeaders;
const url = '/api/Management/ContractRefundPaymentEmailTemplate/:id';
export default async function contractRefundPaymentEmailTemplateDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
